import React from 'react';
import BackToTop from '@/components/ui/BackToTop/BackToTop';
import CustomerService from '@/components/ui/CustomerService/CustomerService';

interface FloatingComponentsProps {
  showBackToTop?: boolean;
  showCustomerService?: boolean;
  backToTopThreshold?: number;
}

const FloatingComponents: React.FC<FloatingComponentsProps> = ({
  showBackToTop = true,
  showCustomerService = true,
  backToTopThreshold = 300,
}) => {
  return (
    <>
      {showBackToTop && <BackToTop threshold={backToTopThreshold} />}
      {showCustomerService && <CustomerService />}
    </>
  );
};

export default FloatingComponents;